export default __webpack_public_path__ + "static/platek-5a7f6d077809f47df1f667aaab219d36.jpg";